import {
  getChromeWebNavigation,
  getChromeWebRequest,
} from '../chrome/wrappers';
import { processNetworkRequest } from './httpEvents';
import { processWebNavigation } from './navigationEvents';
import { setupContentHiding } from '../contentHider/contentHiderService';

export const setupNavigation = () => {
  // Setup content hider to prevent showing the page content while getting the verdict
  setupContentHiding();
  // Register HTTP(s) requests listener (includes document + background requests)
  getChromeWebRequest().onBeforeRequest.addListener(
    onBeforeRequestHandler,
    {
      urls: ['http://*/*', 'https://*/*'],
      types: ['main_frame', 'xmlhttprequest'],
    },
    ['requestBody']
  );
  // Register HTTP(s) navigation events listener (excluding background requests)
  getChromeWebNavigation().onCommitted.addListener(processWebNavigation, {
    url: [
      {
        schemes: ['http', 'https'],
      },
    ],
  });
  // Register listener for YouTube navigation page updates.
  // Navigation inside YouTube does not trigger onCommitted events, but onHistoryStateUpdated events.
  getChromeWebNavigation().onHistoryStateUpdated.addListener(
    processWebNavigation,
    {
      url: [
        {
          hostSuffix: 'youtube.com',
        },
      ],
    }
  );
};

export const onBeforeRequestHandler = (
  details: chrome.webRequest.WebRequestBodyDetails
): chrome.webRequest.BlockingResponse => {
  processNetworkRequest(details);
  // We don't want to block the request
  return { cancel: false };
};
